import moment from "moment";

export function getFormatDate(dateString) {
  const formattedDate = moment(dateString).format("YYYY-MM-DD");
  return formattedDate;
}
